import { render, staticRenderFns } from "./NameBadge.vue?vue&type=template&id=ed0d0566&scoped=true"
import script from "./NameBadge.vue?vue&type=script&lang=ts"
export * from "./NameBadge.vue?vue&type=script&lang=ts"
import style0 from "./NameBadge.vue?vue&type=style&index=0&id=ed0d0566&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0d0566",
  null
  
)

export default component.exports